import styled from '@emotion/styled';
import { Breadcrumb, Divider, Image, Space } from 'antd';
import { FaHome } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import { ROUTES } from '../../../routes';
import { ORANGE, YELLOW } from '../../../shared/colors';
import { Footer } from '../../homePage/components/Footer';
import { Layout } from '../../shared/Layout';
import { FiscaBox } from '../components/FiscaBox';

const Container = styled.div`
  // height: calc(100vh - 32px);
  background-color: white;

  .banner {
    min-height: 300px;
    background-color: white;
    background-image: url('assets/images/fisca.jpg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    > .black-background {
      padding: 5% 15% 5% 15%;
      background-color: rgba(0, 0, 0, 0.6);
      width: 100%;
      min-height: 300px;
    }

    .banner-head {
      align-items: center;
    }

    .banner-logo,
    .banner-logo .ant-image-img {
      width: 130px;
    }

    .brand-title {
      font-family: Poppins-B;
      font-size: clamp(27px, 4vw, 35px);
      line-height: 1.1;
    }

    .page-title {
      color: white;
      font-family: Poppins-B;
      font-size: clamp(24px, 3.2vw, 30px);
      line-height: 1.15;
    }

    .bread-crumb {
      font-size: 14px;
      margin-top: 10px;

      span {
        color: white;
        font-family: Poppins-L;
      }
    }

    .menus {
      display: flex;
      overflow-x: auto;
      padding-bottom: 4px;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }

      > p {
        color: white;
        flex: 0 0 auto;
        text-transform: uppercase;
        font-family: Poppins-L;
        font-size: 14px;
        padding: 4.5px 5px;
        margin-right: 0px;
        text-align: center;

        &:hover {
          background-color: ${YELLOW};
          cursor: pointer;
        }
      }
    }
  }

  > .content {
    min-height: 400px;
    background-color: white;
    color: black;
    padding: 2% 15%;

    > h2 {
      font-family: Poppins-B;
      font-size: 25px;
      margin-bottom: 15px;
    }

    > div {
      display: flex;
      flex-wrap: wrap;
      gap: 24px;
      margin-top: 25px;
    }
  }

  .text {
    font-size: 16px;
    color: #424242;
    line-height: 1.65;
    max-width: 850px;
  }

  @media (max-width: 767px) {
    .banner {
      min-height: 292px;

      > .black-background {
        min-height: 292px;
        padding: 28px 24px 22px;
      }

      .banner-head {
        display: flex;
      }

      .banner-logo,
      .banner-logo .ant-image-img {
        width: 90px;
      }

      .bread-crumb {
        margin-top: 16px;
      }

      .menus {
        margin-left: -24px;
        margin-right: -24px;
        padding-left: 24px;
        padding-right: 24px;

        > p {
          font-size: 13px;
          margin-bottom: 0;
        }
      }
    }

    > .content {
      padding: 30px 24px;

      > div {
        display: grid;
        grid-template-columns: 1fr;
      }
    }
  }
`;

export const FiscaliteComptaPage = () => {
  const history = useHistory();

  return (
    <Layout>
      <Container>
        <div className='banner'>
          <div className='black-background'>
            <Space size={10} className='banner-head'>
              <Image
                alt='moranje-logo'
                className='banner-logo'
                src='assets/images/moranje-logo.png'
                width={130}
                preview={false}
                style={{ objectFit: 'contain', cursor: 'pointer' }}
              />
              <div>
                <div className='brand-title'>
                  <span style={{ color: ORANGE }}>Moranj</span>
                  <span style={{ color: '#6d4c41' }}>E</span>
                  <span style={{ color: YELLOW }}>trade</span>
                </div>
                <div className='page-title'>Fiscalité & Comptabilité</div>
              </div>
            </Space>
            <Breadcrumb separator='>' className='bread-crumb'>
              <Breadcrumb.Item>
                <FaHome style={{ marginRight: 5 }} />
                <span>Accueil</span>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <span>Fiscalité & Comptabilité</span>
              </Breadcrumb.Item>
            </Breadcrumb>
            <Divider style={{ backgroundColor: 'white', marginBottom: 0 }} />

            <div className='menus'>
              {FISCA.map((form, i) => (
                <p key={i} onClick={() => history.push(form.link)}>
                  {form.sumaryLabel}
                </p>
              ))}
            </div>
          </div>
        </div>

        <div className='content'>
          <h2>Fiscalité & Comptabilité</h2>
          <p className='text'>
            Explorez les notions comptables, fiscales et réglementaires qui
            structurent la gestion des obligations et l'analyse financière.
          </p>

          <div>
            {FISCA.map((form, i) => (
              <span key={i} onClick={() => history.push(form.link)}>
                <FiscaBox title={form.label} body={form.content} />
              </span>
            ))}
          </div>
        </div>

        <div style={{ backgroundColor: 'white' }}>
          <Footer />
        </div>
      </Container>
    </Layout>
  );
};

const FISCA = [
  {
    label: 'Introduction à la comptabilité financière',
    sumaryLabel: 'Comptabilité financière',
    link: ROUTES.FISCA.COMPTA_FINANCE,
    content: 'Lire les principaux états et flux financiers.',
  },
  {
    label: 'Comptabilité des obligations',
    sumaryLabel: 'Comptabilité des obligations',
    link: ROUTES.FISCA.COMPTA_OBLIG,
    content: 'Traiter les écritures liées aux titres obligataires.',
  },
  {
    label: 'Fiscalité des obligations',
    sumaryLabel: 'Fiscalité des obligations',
    link: ROUTES.FISCA.FISCALITE_OBLIG,
    content: 'Comprendre les impacts fiscaux des revenus obligataires.',
  },
  {
    label: 'Analyse des états financiers',
    sumaryLabel: 'Analyse des états financiers',
    link: ROUTES.FISCA.ANALYSE_ETAT,
    content: 'Interpréter bilan, résultat et indicateurs clés.',
  },
  {
    label: 'Gestion des risques financiers',
    sumaryLabel: 'Risques financiers',
    link: ROUTES.FISCA.RISQUE_FINANCE,
    content: 'Identifier les risques et les leviers de maîtrise.',
  },
  {
    label: 'Éthique et réglementation',
    sumaryLabel: 'Éthique & réglementation',
    link: ROUTES.FISCA.ETHIQUE_REGL,
    content: 'Situer les pratiques dans leur cadre réglementaire.',
  },
];
